var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame108(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 26.6666C23.1046 26.6666 24 25.7712 24 24.6666C24 23.562 23.1046 22.6666 22 22.6666C20.8954 22.6666 20 23.562 20 24.6666C20 25.7712 20.8954 26.6666 22 26.6666Z",
    fill: "url(#paint0_linear_364_1126)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.777 24.1456C29.1591 22.5715 28.0929 21.2133 26.7105 20.2394C25.3281 19.2654 23.6902 18.7186 22 18.6666C20.3098 18.7186 18.6719 19.2654 17.2895 20.2394C15.9071 21.2133 14.8409 22.5715 14.223 24.1456L14 24.6666L14.223 25.1876C14.8409 26.7617 15.9071 28.1199 17.2895 29.0938C18.6719 30.0678 20.3098 30.6146 22 30.6666C23.6902 30.6146 25.3281 30.0678 26.7105 29.0938C28.0929 28.1199 29.1591 26.7617 29.777 25.1876L30 24.6666L29.777 24.1456ZM22 28.6666C21.2089 28.6666 20.4355 28.432 19.7777 27.9925C19.1199 27.5529 18.6072 26.9282 18.3045 26.1973C18.0017 25.4664 17.9225 24.6622 18.0769 23.8862C18.2312 23.1103 18.6122 22.3976 19.1716 21.8382C19.731 21.2788 20.4437 20.8978 21.2196 20.7435C21.9956 20.5891 22.7998 20.6683 23.5307 20.9711C24.2616 21.2738 24.8864 21.7865 25.3259 22.4443C25.7654 23.1021 26 23.8755 26 24.6666C25.9987 25.7271 25.5768 26.7437 24.827 27.4936C24.0771 28.2434 23.0605 28.6653 22 28.6666Z",
    fill: "url(#paint1_linear_364_1126)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28.6666H8V4.66659H16V10.6666C16.0016 11.1965 16.2128 11.7043 16.5875 12.0791C16.9623 12.4538 17.4701 12.665 18 12.6666H24V16.6666H26V10.6666C26.0035 10.5352 25.9785 10.4045 25.9268 10.2837C25.875 10.1629 25.7976 10.0547 25.7 9.96659L18.7 2.96659C18.612 2.86894 18.5038 2.79154 18.3829 2.73975C18.2621 2.68796 18.1314 2.663 18 2.66659H8C7.47005 2.66817 6.96227 2.8794 6.58753 3.25413C6.2128 3.62886 6.00158 4.13665 6 4.66659V28.6666C6.00158 29.1965 6.2128 29.7043 6.58753 30.0791C6.96227 30.4538 7.47005 30.665 8 30.6666H12V28.6666ZM18 5.06659L23.6 10.6666H18V5.06659Z",
    fill: "url(#paint2_linear_364_1126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_364_1126",
    x1: 22,
    y1: 22.6666,
    x2: 22,
    y2: 26.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84BE08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_364_1126",
    x1: 22,
    y1: 18.6666,
    x2: 22,
    y2: 30.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84BE08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_364_1126",
    x1: 16.0002,
    y1: 2.66625,
    x2: 16.0002,
    y2: 30.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84BE08"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame108);
export default __webpack_public_path__ + "static/media/Frame 108.908ba61a6b684b68ea8f1b721b9f97f7.svg";
export { ForwardRef as ReactComponent };